import { CORE_APPEARANCE, coreColorCss } from './coreAppearance';
import { CORE_PHASE_RANK } from './corePhases';

const FORMS = {
  containment: { name: 'NULL PRISM', body: 0x090611, emissive: 0x200d38 },
  fracture: { name: 'RIFT SHARD', body: 0x030d13, emissive: 0x07303d },
  emergence: { name: 'VOID HEART', body: 0x120615, emissive: 0x3a0a30 },
  evolution: { name: 'ABYSS CROWN', body: 0x14040b, emissive: 0x42091d },
  meltdown: { name: 'SINGULARITY', body: 0x120603, emissive: 0x521507 },
};

const APPEARANCES = Object.fromEntries(
  Object.entries(FORMS).map(([phase, form]) => {
    const palette = CORE_APPEARANCE[phase];
    return [
      phase,
      {
        ...form,
        phase,
        level: CORE_PHASE_RANK[phase],
        dieType: `core:${phase}`,
        color: coreColorCss(palette.hot),
        accent: palette.attack,
        light: palette.light,
        metalness: 0.94,
        roughness: 0.24,
      },
    ];
  })
);

export const getCoreDieAppearance = (phase) =>
  APPEARANCES[phase] || APPEARANCES.containment;

// The launch projectile and the board die use the same engraved face plates.
export const paintCoreDieFaceSkin = (context, width, height, phase) => {
  const skin = getCoreDieAppearance(phase);
  const accent = coreColorCss(skin.accent);
  context.save();
  context.scale(width / 512, height / 512);
  context.shadowBlur = 0;
  const metal = context.createRadialGradient(230, 210, 25, 256, 256, 360);
  metal.addColorStop(0, '#020207');
  metal.addColorStop(0.6, coreColorCss(skin.body));
  metal.addColorStop(1, coreColorCss(skin.emissive));
  context.fillStyle = metal;
  context.fillRect(0, 0, 512, 512);

  const polygon = (points) => {
    context.beginPath();
    points.forEach(([x, y], index) =>
      index ? context.lineTo(x, y) : context.moveTo(x, y)
    );
    context.closePath();
    context.stroke();
  };
  context.strokeStyle = accent;
  context.lineWidth = 5;
  context.globalAlpha = 0.85;
  polygon([
    [70, 20],
    [442, 20],
    [492, 70],
    [492, 442],
    [442, 492],
    [70, 492],
    [20, 442],
    [20, 70],
  ]);
  context.lineWidth = 2;
  context.globalAlpha = 0.32;
  polygon([
    [80, 43],
    [432, 43],
    [469, 80],
    [469, 432],
    [432, 469],
    [80, 469],
    [43, 432],
    [43, 80],
  ]);

  // Leave the center clear so every rolled number remains legible.
  context.globalAlpha = 0.7;
  context.lineWidth = 6;
  for (let corner = 0; corner < 4; corner += 1) {
    context.save();
    context.translate(256, 256);
    context.rotate((corner * Math.PI) / 2);
    context.beginPath();
    context.moveTo(-177, -107);
    context.lineTo(-177, -152);
    context.lineTo(-152, -177);
    context.lineTo(-107, -177);
    context.stroke();
    context.restore();
  }
  context.lineWidth = 3;
  if (skin.level === 0) {
    for (const y of [66, 446]) {
      context.strokeRect(211, y - 9, 90, 18);
      context.fillStyle = accent;
      context.fillRect(251, y - 16, 10, 32);
    }
  } else if (skin.level === 1 || skin.level === 4) {
    for (let index = 0; index < (skin.level === 4 ? 8 : 4); index += 1) {
      context.save();
      context.translate(256, 256);
      context.rotate((index * Math.PI) / (skin.level === 4 ? 4 : 2));
      context.beginPath();
      context.moveTo(-100, -232);
      context.lineTo(-79, -194);
      context.lineTo(-109, -170);
      context.lineTo(-88, -126);
      context.stroke();
      context.restore();
    }
  } else {
    context.globalAlpha = 0.38;
    context.beginPath();
    context.arc(256, 256, 184, 0, Math.PI * 2);
    context.stroke();
    context.globalAlpha = 0.85;
    for (const y of [65, 447]) {
      polygon([
        [256, y - 24],
        [277, y],
        [256, y + 24],
        [235, y],
      ]);
    }
    if (skin.level === 3) {
      polygon([
        [170, 70],
        [199, 98],
        [224, 64],
        [256, 99],
        [288, 64],
        [313, 98],
        [342, 70],
      ]);
      polygon([
        [170, 442],
        [199, 414],
        [224, 448],
        [256, 413],
        [288, 448],
        [313, 414],
        [342, 442],
      ]);
    }
  }

  context.globalAlpha = 0.8;
  context.fillStyle = skin.color;
  for (let index = 0; index <= skin.level; index += 1) {
    const x = 256 + (index - skin.level / 2) * 20;
    context.fillRect(x - 3, 30, 6, 12);
    context.fillRect(x - 3, 470, 6, 12);
  }
  context.restore();
};
